import styled from 'styled-components'

const ShippingItemDescription = styled.div`
  display: flex;
  flex-direction: column;
`

export default ShippingItemDescription
